"use client";

import { useEffect } from "react";
import { usePlatformDataTracking } from "@/lib/PlatformData/platformDataStore";
import { logToSentry } from "../platformDataErrorTracking";
import { PlatformDataEvents } from "../PlatformDataEvents";
import { useIsLoggedIn } from "../../Hooks/useIsLoggedIn";
import { getPageTrackingData } from "../helpers/getPageTrackingData";
import { getUserTrackingData } from "../helpers/getUserTrackingData";
import { getTrafficType } from "@/lib/Helpers/trafficType";
import { AppConfig } from "@/lib/Types/AppConfig";

interface UseVoucherRedemptionTrackingProps {
  appConfig: AppConfig;
  isLoading: boolean;
  isConfirmation?: boolean;
}

export const useVoucherRedemptionTracking = ({
  appConfig,
  isLoading,
  isConfirmation = false,
}: UseVoucherRedemptionTrackingProps) => {
  const { pushEvent } = usePlatformDataTracking();
  const { WlConfig, envConfig, userData } = appConfig;
  const isLoggedIn = useIsLoggedIn();

  // Track when voucher redemption attempt is made
  useEffect(() => {
    if (isLoading || !envConfig) return;

    try {
      const section = isConfirmation
        ? "voucherRedeem.confirmation"
        : "voucherRedeem";

      pushEvent({
        event: PlatformDataEvents.VISIT,
        transactionAffiliation: "WEGDE",
        page: getPageTrackingData({
          WlConfig,
          section,
        }),
        user: getUserTrackingData({
          userData,
          isLoggedIn,
          event: PlatformDataEvents.VISIT,
        }),
        trafficType: getTrafficType(),
        platformName: "ICARUS",
      });
    } catch (err) {
      logToSentry(err as Error, [
        ["function", "useVoucherRedemptionTracking"],
        ["section", isConfirmation ? "confirmation" : "voucherRedeem"],
      ]);
    }
  }, [
    isLoading,
    isConfirmation,
    pushEvent,
    WlConfig,
    envConfig,
    userData,
    isLoggedIn,
  ]);
};
